import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_user = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_user, "id", t.id),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "username", t.username),
  /* [] */
  0]]);
});
var read_user = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_user, param);
    }, json),
    username: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("username", Atdgen_codec_runtime.Decode.string, param);
    }, json)
  };
});

function write_t(write__a) {
  return Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_event, "id", t.id),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.make(function (x) {
      if (typeof x === "number") {
        return Atdgen_codec_runtime.Encode.constr0("System");
      } else {
        return Atdgen_codec_runtime.Encode.constr1("User", write_user, x[1]);
      }
    }), "user", t.user),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$float, "timestamp", t.timestamp),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__a, "info", t.info),
    /* [] */
    0]]]]);
  });
}

function read_t(read__a) {
  return Atdgen_codec_runtime.Decode.make(function (json) {
    var partial_arg = Atdgen_codec_runtime.Decode.$$enum(
    /* :: */
    [
    /* tuple */
    ["User",
    /* `Decode */
    [427938126, function (param) {
      return Atdgen_codec_runtime.Decode.map(function (x) {
        return (
          /* `User */
          [948354667, x]
        );
      }, read_user, param);
    }]],
    /* :: */
    [
    /* tuple */
    ["System",
    /* `Single */
    [-306849112,
    /* System */
    662113039]],
    /* [] */
    0]]);
    return {
      id: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_event, param);
      }, json),
      user: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("user", partial_arg, param);
      }, json),
      timestamp: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("timestamp", Atdgen_codec_runtime.Decode.$$float, param);
      }, json),
      info: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("info", read__a, param);
      }, json)
    };
  });
}

function write_events(write__a) {
  var partial_arg = write_t(write__a);
  return function (param) {
    return Atdgen_codec_runtime.Encode.list(partial_arg, param);
  };
}

function read_events(read__a) {
  var partial_arg = read_t(read__a);
  return function (param) {
    return Atdgen_codec_runtime.Decode.list(partial_arg, param);
  };
}

var read_user_id = Id_bs$SolvuuApi0.read_user;
var write_user_id = Id_bs$SolvuuApi0.write_user;
var read_event_id = Id_bs$SolvuuApi0.read_event;
var write_event_id = Id_bs$SolvuuApi0.write_event;
export { read_user_id, write_user_id, read_user, write_user, read_event_id, write_event_id, read_t, write_t, read_events, write_events };
/* write_user Not a pure module */